var main = require('client_core/main');

main.baseFiles.header = require('./components/header');

module.exports = main;
